// extracted by mini-css-extract-plugin
module.exports =  {"milestone-flag-logo":"sEh9izP","milestoneFlagLogo":"sEh9izP","milestone-payment-title":"g4V97bS","milestonePaymentTitle":"g4V97bS"};